import { Controller } from "@hotwired/stimulus"
import { renderStreamMessage, visit } from "@hotwired/turbo"

export default class extends Controller {
  static values = {
    url: String,
    pollInterval: { type: Number, default: 15_000 }
  }

  connect() {
    this.scheduleNext()
  }

  disconnect() {
    clearTimeout(this.timer)
    this.abortController?.abort()
  }

  scheduleNext() {
    this.timer = setTimeout(() => this.poll(), this.pollIntervalValue)
  }

  async poll() {
    clearTimeout(this.timer)
    this.abortController = new AbortController()
    let keepPolling = true
    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "text/vnd.turbo-stream.html" },
        signal: this.abortController.signal
      })
      if (this.sessionExpired(response)) {
        keepPolling = false
        if (this.element.isConnected) visit(window.location.href, { action: "replace" })
      } else if (response.ok && response.headers.get("Content-Type")?.includes("text/vnd.turbo-stream.html")) {
        const content = await response.text()
        if (this.element.isConnected) renderStreamMessage(content)
      } else {
        console.warn(`Gateway dashboard poll ignored: ${response.status} ${response.headers.get("Content-Type")}`)
      }
    } catch (error) {
      if (error.name !== "AbortError") console.error(error)
    } finally {
      if (keepPolling && this.element.isConnected) this.scheduleNext()
    }
  }

  // fetch follows the redirect to the sign-in page, so an expired session arrives as a redirected 200 HTML response
  sessionExpired(response) {
    return response.redirected || response.status === 401 || response.status === 403
  }
}
